// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ClassListPagingResultModel from '../../model/class-list-paging-result-model';
import ClassListPagingResultDTO from '../dto/class-list-paging-result-dto';
import dtoSchema from '../schemas/class-list-paging-result-schema';
import ClassListModel from '../../model/class-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ClassListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ClassListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ClassListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: ClassListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<ClassListPagingResultDTO>): ClassListPagingResultModel;
  static toModel(dto: DeepPartial<ClassListPagingResultDTO> | undefined | null): ClassListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<ClassListPagingResultDTO> | undefined | null): ClassListPagingResultModel | undefined {
    return dto ? new ClassListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ClassListPagingResultModel> | ClassListPagingResultModel): ClassListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as ClassListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ClassListPagingResultModel, can not map to ClassListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
